import { types } from 'mobx-state-tree';

/**
 * Order Request model.
 */
export const OptionGroupModel = types.model('OptionGroup', {
  id: types.string,
  allowMultiple: types.boolean,
  limit: types.maybe(types.number),
  name: types.string,
  options: types.array(
    types.model({
      name: types.string,
      price: types.maybe(types.number),
      value: types.string,
    })
  ),
  required: types.boolean,
});
